// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"253":"7f7515e2","415":"8ad21895"}[chunkId] + ".chunk.css";
};